export const comments_5053767 = {"data":{"data":[],"links":{}}}